import DesktopSideBar from './DesktopSideBar';
import MobileSideBar from './MobileSideBar';

const SideBar = DesktopSideBar;

export default Object.assign(SideBar, {
  Desktop: DesktopSideBar,
  Mobile: MobileSideBar,
});
